export const HELP_TEXT_URL = "Enter base URL of site that will be integrated."

export const LOAN_TYPE_OPTIONS = [
  {
    id: "conventional",
    name: "Conventional"
  },
  {
    id: "va",
    name: "VA"
  },
  {
    id: "usda",
    name: "USDA"
  },
  {
    id: "fha",
    name: "FHA"
  },
  {
    id: "arm",
    name: "ARM"
  }
]

export const LOAN_TYPE_OPTIONS_WITH_NONQM = [
  ...LOAN_TYPE_OPTIONS,
  {
    id: "nonqm",
    name: "Non-QM"
  }
]

export const NONQM_PROGRAM_OPTIONS = [
  { id: "dscr", name: "Investor DSCR" },
  { id: "bank_stmt_12mo", name: "Bank Statement 12 Months" },
  { id: "bank_stmt_24mo", name: "Bank Statement 24 Months" },
  { id: "biz_bank_stmt_12mo", name: "Business Bank Statement 12 Months" },
  { id: "biz_bank_stmt_24mo", name: "Business Bank Statement 24 Months" },
  { id: "alt_doc", name: "2-Year Alt Doc" },
  { id: "asset_qualifier", name: "Asset Qualifier" },
  { id: "full_doc", name: "Full Doc Non-QM" }
]

export const LOAN_TERM_OPTIONS = [
  {
    id: "30",
    name: "30 Year Fixed"
  },
  {
    id: "20",
    name: "20 Year Fixed"
  },
  {
    id: "15",
    name: "15 Year Fixed"
  }
]

export const ARM_TERM_OPTIONS = [
  {
    id: "10",
    name: "10y ARM"
  },
  {
    id: "7",
    name: "7y ARM"
  },
  {
    id: "5",
    name: "5y ARM"
  },
  {
    id: "3",
    name: "3y ARM"
  }
]

export const PROPERTY_TYPE_OPTIONS = [
  {
    id: "single_family_home",
    name: "Single family home"
  },
  {
    id: "townhome",
    name: "Townhome"
  },
  {
    id: "condominium",
    name: "Condominium"
  },
  {
    id: "multi_tenant_home",
    name: "Multi family"
  }
]

export const RESIDENCY_TYPE_OPTIONS = [
  {
    id: "primary_home",
    name: "Primary home"
  },
  {
    id: "second_home",
    name: "Secondary home"
  },
  {
    id: "rental_home",
    name: "Rental home"
  }
]

export const LOAN_PURPOSE_OPTIONS = [
  { id: "purchase", name: "Purchase" },
  { id: "refinance", name: "Refinance" }
]

export const ENGAGEMENT_STATUS_OPTIONS = [
  { id: "active", name: "Active" },
  { id: "disabled", name: "Disabled" },
  { id: "deleted", name: "Deleted" }
]

export const VA_FUNDING_FEE_OPTIONS = [
  {
    id: "first_time",
    name: "First Time"
  },
  {
    id: "second_time",
    name: "Second Time"
  },
  {
    id: "exempt",
    name: "Exempt"
  }
] as const
export type VA_FUNDING_FEE_TYPE = typeof VA_FUNDING_FEE_OPTIONS[number]["id"]
